// Modal.js
import React from 'react';

const TONES = {
  info: {
    header: "bg-gradient-to-r from-blue-900 via-blue-800 to-cyan-700",
    confirmButton: "bg-blue-700 hover:bg-blue-800",
  },
  success: {
    header: "bg-gradient-to-r from-emerald-700 via-emerald-600 to-green-600",
    confirmButton: "bg-emerald-600 hover:bg-emerald-700",
  },
};

export function ModalConfirm({
  isOpen,
  onClose,
  onConfirm,
  title = "Enviar a verificación",
  message = "Vas a enviar la solicitud para su revisión. Verifica que toda la información esté completa antes de continuar.",
  warningText = "Importante: después del envío, el proceso pasa al estado de revisión.",
  confirmLabel = "Sí, enviar a revisión",
  tone = "info",
}) {
  if (!isOpen) return null; // Si el modal no está abierto, no se renderiza
  const toneStyles = TONES[tone] || TONES.info;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm px-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="confirm-send-title">
        <div className={`${toneStyles.header} px-6 py-5 text-white`}>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 12l5 5L20 6" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.14em] text-blue-100">Confirmación</p>
              <h3 id="confirm-send-title" className="text-lg font-bold">{title}</h3>
            </div>
          </div>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-slate-700 leading-relaxed">
            {message}
          </p>

          {warningText && (
            <div className="mt-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
              <p className="text-xs text-amber-800 font-medium">
                {warningText}
              </p>
            </div>
          )}

          <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
            <button
              className="w-full sm:w-auto px-4 py-2.5 rounded-lg border border-slate-300 bg-white text-slate-700 font-semibold hover:bg-slate-50 transition-colors"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              className={`w-full sm:w-auto px-4 py-2.5 rounded-lg text-white font-semibold shadow-sm transition-colors ${toneStyles.confirmButton}`}
              onClick={() => {
                onConfirm(); // Ejecutar la acción al confirmar
                onClose();   // Cerrar el modal
              }}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

